import prodFeatureFlags from '../config/featureFlags-prod.json';
import testFeatureFlags from '../config/featureFlags-test.json';

/**
 * helper function to convert string in localStorage to boolean value
 * @param {string} booleanString string to be converted to boolean value
 */
export function stringToBoolean(booleanString) {
  return booleanString === 'true';
}

/**
 * Gets the locally set feature flags
 */
export function getLocalFeatureFlags() {
  const localFeatureFlagPrefix = 'featureFlags.';
  const localFeatureFlags = {};

  Object.keys(localStorage)
    .filter((key) => key.match(localFeatureFlagPrefix))
    .forEach((key) => {
      localFeatureFlags[key.slice(localFeatureFlagPrefix.length)] = stringToBoolean(localStorage[key]);
    });

  return localFeatureFlags;
}

/**
 * Method to retrieve all the feature flags specified in the application.
 * Locally set feature flags take precendece over environment flags for local testing and verification
 */
export function getFeatureFlags() {
  const featureFlags = process.env.REACT_APP_ENV === 'production' ? prodFeatureFlags : testFeatureFlags;
  const localFeatureFlags = getLocalFeatureFlags();

  // override setup with local feature flags
  Object.keys(localFeatureFlags).forEach((localFeatureFlag) => {
    featureFlags[localFeatureFlag] = localFeatureFlags[localFeatureFlag];
  });

  return featureFlags;
}
